<section class=" search-page notifications-page pd-tb">
  <div class="container">
        <div class="search-home">

            <div class="sub-heading">
              <h2 class="pageTitle"> Notifications </h2>
            </div>
        <div class="container p-0 infinite-scroll" infinite-scroll [infiniteScrollDistance]="modalScrollDistance"
			[infiniteScrollThrottle]="modalScrollThrottle" [scrollWindow]="false" (scrolled)="onModalScrollDown()">
            <!-- 1 -->
            <div class="card-holder" *ngFor="let data of allData">
              <div class="top-box row"  *ngIf="data.notificationType != '1'">
                  <div class="author-profile col-md-6">
                    <div class="imgbox">
                      <img src="../../../assets/images/profile-img.jpg">
                      <span *ngIf="data.isRead == 0 && data.notificationType != '1'" class="dotGreen"></span>
                    </div>
                      <div class="admin-name">                
                        <h6> {{data.title}} </h6>
                        <p> {{data.message}} </p>
                      </div>
                  </div> 
                  <div class="author-details  col-md-6">
                      <span class="notifications-time"> {{data.createdAt | timeAgo}} </span> 
                      <a href="javascript:void(0);" *ngIf="data.notificationType != '1' && data.notificationType != '11' && data.notificationType != '12'"  class="apply_btn" (click)="toRedirect(data)"> View Now </a> 
                      <a href="javascript:void(0);" *ngIf="data.notificationType == '11' || data.notificationType == '12'"  class="apply_btn" (click)="toRedirect(data)"> View Job </a>   
                  </div>
              </div>
              <a href="javascript:void(0);" *ngIf="data.notificationType == '1'" routerLink="/dashboard-job">  
              <div class="top-box row">
                  <div class="author-profile col-md-6">
                    <div class="imgbox">
                      <img src="../../../assets/images/profile-img.jpg">
                      <span *ngIf="data.isRead == 0 && data.notificationType != '1'" class="dotGreen"></span>
                    </div>
                      <div class="admin-name">                
                        <h6> {{data.title}} </h6>
                        <p> {{data.message}} </p>
                      </div>
                  </div> 
                  <div class="author-details  col-md-6">
                      <span class="notifications-time"> {{data.createdAt | timeAgo}} </span>  
                  </div>
              </div>
            </a>
            </div> 
            <div class="noDataFound" *ngIf="allData?.length == 0 && noData">
              <h2>No Records Found</h2>
            </div>
          </div>
            <!-- <div class="sub-heading">
              <h4> Today </h4>
            </div> -->


        </div>
  </div>
</section>